import Separator from 'components/privat/Separator'

const Title = ({ children, className, type }) => {
  return type !== 'form' ? (
    <>
      <h1
        className={`font-alliance-medium text-[30px] lg:text-[42px] mb-5 ${className}`}
      >
        {children}
      </h1>
      <Separator />
    </>
  ) : (
    <div className="mb-4 lg:mb-2 border-b border-gray-200 pb-2 false">
      <h2 className="text-[14px] lg:text-lg font-alliance-medium text-blue">
        {children}
      </h2>
    </div>
  )
}

export default Title
